import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default store => ({
  path: "trash-progress-report-sets",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-trash" */ "./components"),
        import(
          /* webpackChunkName: "admin-trash" */ "./modules/TrashProgressReportSetsModules"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const progressReportSetsBin = importedModule1.default;
        injectReducer(store, {
          key: "progressReportSetsBin",
          reducer: progressReportSetsBin,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
});
